import { motion } from 'framer-motion';
import {
  FaPhoneAlt, FaEnvelope, FaWhatsapp,
  FaMapMarkerAlt, FaBuilding,
} from 'react-icons/fa';
import PageHero from '../../components/PageHero/PageHero';
import { COMPANY, WA_LINK, branches } from '../../data/data';
import streetBg from '../../assets/street.jpg';
import './Contact.css';

const CONTACT_CARDS = [
  {
    icon:  FaPhoneAlt,
    label: 'Call Us',
    info:  `${COMPANY.phone1} / ${COMPANY.phone2}`,
    action: { href: `tel:${COMPANY.phone1}`, text: 'Call Now' },
    color:  'blue',
  },
  {
    icon:  FaWhatsapp,
    label: 'WhatsApp',
    info:  `+234 ${COMPANY.phone2}`,
    action: { href: WA_LINK, text: 'Open WhatsApp', target: '_blank' },
    color:  'green',
  },
  {
    icon:  FaEnvelope,
    label: 'Email Us',
    info:  COMPANY.email,
    action: { href: `mailto:${COMPANY.email}`, text: 'Send Email' },
    color:  'orange',
  },
];

export default function Contact() {
  return (
    <>
      <PageHero
        title="Contact"
        highlight="Us"
        subtitle="We have 6 branches across South-West Nigeria. Reach out on WhatsApp, by phone, or visit us in person."
        bgImage={streetBg}
      />

      {/* ── Contact Cards ── */}
      <section className="contact-cards-section section-pad">
        <div className="container">
          <div className="section-header">
            <p className="section-label">Get In Touch</p>
            <h2 className="section-title">We'd Love to <span>Hear From You</span></h2>
          </div>
          <div className="contact-cards">
            {CONTACT_CARDS.map((card, i) => (
              <motion.div
                key={i}
                className={`contact-card contact-card--${card.color}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.12 }}
              >
                <div className="contact-card__icon">
                  <card.icon size={28} />
                </div>
                <p className="contact-card__label">{card.label}</p>
                <p className="contact-card__info">{card.info}</p>
                <a
                  href={card.action.href}
                  target={card.action.target || '_self'}
                  rel="noreferrer"
                  className="contact-card__btn btn-primary"
                >
                  {card.action.text}
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Branch Offices ── */}
      <section className="branches-section section-pad">
        <div className="container">
          <div className="section-header" id="locations">
            <p className="section-label">Find Us</p>
            <h2 className="section-title">Our <span>Branch Offices</span></h2>
            <p className="section-desc" style={{ maxWidth: 500 }}>
              Visit any of our six offices across South-West Nigeria for in-person assistance.
            </p>
          </div>

          <div className="branches-grid">
            {branches.map((branch, i) => (
              <motion.div
                key={branch.id}
                className={`branch-card ${branch.isHQ ? 'branch-card--hq' : ''}`}
                initial={{ opacity: 0, scale: 0.96 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <div className="branch-card__header">
                  <div className="branch-card__icon">
                    {branch.isHQ ? <FaBuilding size={18} /> : <FaMapMarkerAlt size={18} />}
                  </div>
                  {branch.isHQ && <span className="branch-hq-badge">Head Office</span>}
                </div>
                <h3 className="branch-card__city">{branch.city}</h3>
                <p  className="branch-card__address">{branch.address}</p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(branch.address)}`}
                  target="_blank"
                  rel="noreferrer"
                  className="branch-card__map-link"
                >
                  View on Map →
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Bottom CTA ── */}
      <section className="contact-cta-section section-pad">
        <div className="container">
          <motion.div
            className="contact-cta-inner"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaWhatsapp className="contact-cta-icon" />
            <div>
              <h3>Quickest response is via WhatsApp</h3>
              <p>Our team is available daily. Send us a message and we'll respond within minutes.</p>
            </div>
            <a href={WA_LINK} target="_blank" rel="noreferrer" className="btn-primary">
              <FaWhatsapp /> Message Us Now
            </a>
          </motion.div>
        </div>
      </section>
    </>
  );
}
